import { Store } from '@/types/auth'

export const getStoreHash = (store: Store) => store.hash
